.alignWithoutPadding {
  margin-left: -1rem;
}
